// Mock data for B2BTechLeads website

export const siteConfig = {
  phone: '941-799-8809',
  email: 'info@b2btechleads.com',
  address: '15 Business Ave, Suite 500, Orlando, FL 34236',
  linkedin: 'https://www.linkedin.com/company/b2btechleads',
  tagline: 'B2B Tech Leads',
};

export const heroSlides = [
  {
    id: 1,
    badge: 'Lead Generation',
    title: 'Increase Sales And Revenues',
    subtitle: '',
    description: 'At B2BTechLeads we generate quality business leads using the topnotch channels. Since consistent lead generation is not an easy task, our experts make this job way simpler for you.',
    cta: 'Know More',
    ctaLink: '/nurture-marketing',
    bgColor: '#e8edf2',
    image: 'https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=700&q=60',
  },
  {
    id: 2,
    badge: 'Email Marketing',
    title: 'Triple Your Leads',
    subtitle: 'Add a Spark to Email Campaign',
    description: 'On Demand Marketing Outsourcing, Content Marketing and Social Media Marketing services take your business to the next level.',
    cta: 'Get Started',
    ctaLink: '/marketing-leads',
    bgColor: '#edf2f4',
    image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=700&q=60',
  },
  {
    id: 3,
    badge: 'Database Assessment',
    title: 'Quality Data, Better Results',
    subtitle: '',
    description: 'B2BTechleads brings your direction an assembly of Data Assessment administrations. Through our element administrations you can invigorate, upgrade, accept and remedy your data.',
    cta: 'Learn More',
    ctaLink: '/database-assessment',
    bgColor: '#f0f4f0',
    image: 'https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?w=700&q=60',
  },
];

export const homeCategories = [
  {
    id: 1,
    title: 'Product & Services',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=70',
    links: [
      { label: 'Marketing Leads', href: '/marketing-leads' },
      { label: 'Technology Leads', href: '/technology-leads' },
      { label: 'Nurture Marketing', href: '/nurture-marketing' },
      { label: 'Database Assessment', href: '/database-assessment' },
      { label: 'Market Survey', href: '/market-survey' },
    ],
  },
  {
    id: 2,
    title: 'Your Challenges',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&q=70',
    links: [
      { label: 'Need More Leads', href: '/need-more-leads' },
      { label: 'Email Campaign Reports', href: '/email-campaign-reports' },
      { label: 'Brand Awareness', href: '/brand-awareness' },
      { label: 'Marketing Database', href: '/marketing-database' },
    ],
  },
  {
    id: 3,
    title: 'Learning Center',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&q=70',
    links: [
      { label: 'Corporate Brochure', href: '/corporate-brochure' },
      { label: 'Complete Solution Guide', href: '/complete-solution-guide' },
      { label: 'Case Studies', href: '/case-studies' },
      { label: 'White Papers', href: '/white-papers' },
    ],
  },
];

export const tabsData = [
  {
    id: 'lead-generation',
    label: 'Lead Generation',
    content: 'At B2BTechleads, we produce quality business leads utilizing the topnotch channels. Since steady lead era is not a simple undertaking, our masters make this employment path more straightforward for you. We deliver targeted leads across multiple channels including telemarketing, email marketing, and postal marketing to ensure maximum reach and conversion rates.',
    link: '/marketing-leads',
  },
  {
    id: 'database-assessment',
    label: 'Database Assessment',
    content: 'B2BTechleads brings your direction an assembly of Data Assessment administrations. Through our element administrations you can invigorate, upgrade, accept and remedy all your information exhibit in your database. We ensure your database is clean, accurate, and always up-to-date with the latest contact information.',
    link: '/database-assessment',
  },
  {
    id: 'market-survey',
    label: 'Market Survey',
    content: 'B2BTechLeads has expertise in market research and survey, we understand what the market wants, and provide the right solutions accordingly. Our comprehensive market surveys help you understand customer behavior, competitive landscape, and emerging trends to make informed business decisions.',
    link: '/market-survey',
  },
];

export const whyChooseUs = [
  '32 Million+ Global B2B Contacts',
  '40+ Industry segments covered',
  'A-Z Marketing Rainbow of B2B Marketing Services',
  '30+ Satisfied Clients & Growing',
  'On-Demand Marketing Outsourcing',
  'Dedicated Account Managers',
];

export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about-us' },
  {
    label: 'Product & Services',
    href: '/product-services',
    dropdown: [
      { label: 'Marketing Leads', href: '/marketing-leads' },
      { label: 'Technology Leads', href: '/technology-leads' },
      { label: 'Nurture Marketing', href: '/nurture-marketing' },
      { label: 'Database Assessment', href: '/database-assessment' },
      { label: 'Market Survey', href: '/market-survey' },
    ],
  },
  {
    label: 'Your Challenges',
    href: '/your-challenges',
    dropdown: [
      { label: 'Need More Leads', href: '/need-more-leads' },
      { label: 'Email Campaign Reports', href: '/email-campaign-reports' },
      { label: 'Brand Awareness', href: '/brand-awareness' },
      { label: 'Marketing Database', href: '/marketing-database' },
    ],
  },
  {
    label: 'Learning Center',
    href: '/learning-center',
    dropdown: [
      { label: 'Corporate Brochure', href: '/corporate-brochure' },
      { label: 'Complete Solution Guide', href: '/complete-solution-guide' },
      { label: 'Case Studies', href: '/case-studies' },
      { label: 'White Papers', href: '/white-papers' },
    ],
  },
  { label: 'Contact', href: '/contact' },
];

export const aboutStats = [
  { value: '200+', label: 'Employees' },
  { value: '32M+', label: 'B2B Contacts' },
  { value: '40+', label: 'Industry Segments' },
  { value: '30+', label: 'Happy Clients' },
];

export const skills = [
  { label: 'Marketing Leads', value: 100 },
  { label: 'Technology Leads', value: 100 },
  { label: 'Database Assessment', value: 95 },
  { label: 'Website Development & SEO', value: 90 },
];

export const services = {
  'marketing-leads': {
    title: 'Marketing Leads',
    description: "At B2BTechLeads, we upgrade our customer's database with new, finish and micro focused on leads. So that there will be no embarrassing calls or speedily offered conciliatories sentiment for arriving at the wrong individual, at the wrong time.",
    items: [
      {
        title: 'Telemarketing Leads',
        desc: "Having a conversation over the phone is the next most productive thing after meeting someone in person. So we provide details of only those leads, who already have a proven interest in a client's product or service.",
      },
      {
        title: 'Email Marketing Leads',
        desc: "Are your prospects in different parts of the world? Is making calls becoming expensive? Have the same profound impact on your prospect's buying decisions with our highly segmented leads.",
      },
      {
        title: 'Postal Marketing Leads',
        desc: "There's something concrete and tangible about seeing an offer in print. Leave the imprint of your marketing message on your prospects' minds with our postal marketing leads.",
      },
      {
        title: 'All-in-One Marketing Leads',
        desc: 'We understand that prospects are everywhere, reachable through multiple means. Sometimes they might get overwhelmed by one type of marketing. So we help you sell your service in a variety of ways.',
      },
    ],
  },
  'technology-leads': {
    title: 'Technology Leads',
    description: 'B2BTechLeads specializes in providing highly targeted technology leads to help IT companies, software vendors, and tech service providers reach the right decision-makers.',
    items: [
      {
        title: 'IT Decision Maker Leads',
        desc: 'Connect directly with CIOs, CTOs, IT Managers and other technology decision makers who are actively evaluating solutions for their organizations.',
      },
      {
        title: 'Software Leads',
        desc: 'Reach companies that are actively looking for software solutions. Our targeted software leads connect you with buyers at the right stage of the buying cycle.',
      },
      {
        title: 'Cloud Computing Leads',
        desc: 'Target organizations exploring or migrating to cloud solutions. Our cloud computing leads are pre-qualified and highly relevant to your offerings.',
      },
      {
        title: 'Cybersecurity Leads',
        desc: 'Connect with IT security professionals and companies investing in cybersecurity solutions. Our leads are verified and come with detailed company profiles.',
      },
    ],
  },
  'nurture-marketing': {
    title: 'Nurture Marketing',
    description: 'Our nurture marketing programs help you build and maintain relationships with prospects over time, keeping them engaged until they are ready to make a purchase decision.',
    items: [
      {
        title: 'Email Nurture Campaigns',
        desc: 'Automated email sequences that deliver the right message at the right time, moving prospects through your sales funnel efficiently.',
      },
      {
        title: 'Content Marketing',
        desc: 'Engaging content that educates and informs your prospects, positioning your brand as a thought leader in your industry.',
      },
      {
        title: 'Social Media Nurturing',
        desc: 'Strategic social media engagement to keep your brand top-of-mind with prospects across LinkedIn, Twitter, and other platforms.',
      },
      {
        title: 'Marketing Automation',
        desc: 'Advanced automation workflows that score, segment, and nurture leads based on their behavior and engagement with your brand.',
      },
    ],
  },
  'database-assessment': {
    title: 'Database Assessment',
    description: 'B2BTechleads brings your direction an assembly of Data Assessment administrations. Through our element administrations you can invigorate, upgrade, accept and remedy all your information exhibit in your database.',
    items: [
      {
        title: 'Data Cleansing',
        desc: 'Remove duplicate, outdated, and inaccurate records from your database to improve the quality of your marketing campaigns.',
      },
      {
        title: 'Data Enrichment',
        desc: 'Enhance your existing records with additional information such as company size, industry, technology stack, and buying intent.',
      },
      {
        title: 'Email Verification',
        desc: 'Verify email addresses in your database to reduce bounce rates, improve deliverability, and protect your sender reputation.',
      },
      {
        title: 'Phone Verification',
        desc: 'Validate and update phone numbers in your contact database to ensure your telemarketing campaigns reach the right people.',
      },
    ],
  },
  'market-survey': {
    title: 'Market Survey',
    description: 'B2BTechLeads has expertise in market research and survey, we understand what the market wants, and provide the right solutions accordingly.',
    items: [
      {
        title: 'Customer Satisfaction Survey',
        desc: 'Measure how well your products and services meet customer expectations and identify areas for improvement.',
      },
      {
        title: 'Competitive Analysis',
        desc: 'Understand your competitive landscape and identify opportunities to differentiate your offerings in the market.',
      },
      {
        title: 'Brand Awareness Research',
        desc: "Measure your brand's visibility and perception in the market to inform your marketing strategy.",
      },
      {
        title: 'Product Development Research',
        desc: 'Gather insights from potential customers to guide product development and ensure market fit before launch.',
      },
    ],
  },
};

export const challenges = {
  'need-more-leads': {
    title: 'Need More Leads',
    subtitle: 'Scale Your Lead Generation',
    description: 'Struggling to fill your sales pipeline? B2BTechLeads provides comprehensive lead generation solutions that connect you with qualified prospects who are genuinely interested in your products and services.',
    points: [
      'Access to 32 Million+ verified B2B contacts',
      'Multi-channel lead generation approach',
      'Real-time lead delivery and tracking',
      'Industry-specific targeting capabilities',
      'Dedicated account management support',
    ],
  },
  'email-campaign-reports': {
    title: 'Email Campaign Reports',
    subtitle: 'Data-Driven Email Marketing',
    description: 'Poor email campaign performance? Our advanced analytics and reporting tools give you complete visibility into your email marketing performance, helping you optimize for better results.',
    points: [
      'Open rate and click-through rate tracking',
      'A/B testing and optimization tools',
      'Deliverability monitoring and alerts',
      'Audience segmentation analytics',
      'ROI measurement and reporting',
    ],
  },
  'brand-awareness': {
    title: 'Brand Awareness',
    subtitle: 'Build Your Brand Presence',
    description: 'Is your brand getting lost in the noise? Our brand awareness campaigns help you stand out in crowded markets and reach the right audience with your message.',
    points: [
      'Content syndication across top industry publications',
      'Social media amplification campaigns',
      'Thought leadership placement',
      'Display advertising on B2B networks',
      'Webinar and event promotion',
    ],
  },
  'marketing-database': {
    title: 'Marketing Database',
    subtitle: 'Optimize Your Data Assets',
    description: 'Is your marketing database full of outdated or inaccurate data? Our database management solutions help you maintain a clean, accurate, and comprehensive marketing database.',
    points: [
      'Database cleansing and deduplication',
      'Real-time data enrichment',
      'Custom audience segmentation',
      'GDPR and CAN-SPAM compliance',
      'Integration with CRM systems',
    ],
  },
};

export const learningCenter = {
  'corporate-brochure': {
    title: 'Corporate Brochure',
    description: "Download our comprehensive corporate brochure to learn more about B2BTechLeads' full suite of services, our approach to lead generation, and how we can help your business grow.",
    content: 'Our corporate brochure provides an in-depth overview of our services including Marketing Leads, Technology Leads, Nurture Marketing, Database Assessment, and Market Survey.',
  },
  'complete-solution-guide': {
    title: 'Complete Solution Guide',
    description: "A comprehensive guide to all of B2BTechLeads' products and services, with detailed explanations of how each solution can address your specific marketing challenges.",
    content: 'From lead generation to database management, our complete solution guide walks you through every aspect of our offering.',
  },
  'case-studies': {
    title: 'Case Studies',
    description: 'Real-world examples of how B2BTechLeads has helped businesses like yours achieve their marketing and sales goals.',
    items: [
      {
        company: 'Enterprise Software Company',
        result: '300% increase in qualified leads',
        service: 'Technology Leads + Nurture Marketing',
      },
      {
        company: 'IT Services Provider',
        result: '45% reduction in cost per lead',
        service: 'Marketing Leads + Database Assessment',
      },
      {
        company: 'Cloud Solutions Vendor',
        result: '200% growth in pipeline value',
        service: 'All Services Package',
      },
    ],
  },
  'white-papers': {
    title: 'White Papers',
    description: 'In-depth research papers and industry insights from the B2BTechLeads team of marketing experts.',
    items: [
      'The Future of B2B Lead Generation in 2025',
      'Database Marketing Best Practices for IT Companies',
      'Maximizing ROI from Email Marketing Campaigns',
      'Technology Decision Maker Buying Behavior Study',
    ],
  },
};
